var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 33.75,
    fill: "#193051"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8377 50.8772C42.288 49.4737 45.5921 48.7719 48.75 48.7719C51.9079 48.7719 55.1827 49.4737 58.5746 50.8772C62.0249 52.2222 63.75 54.0058 63.75 56.2281V60H33.75V56.2281C33.75 54.0058 35.4459 52.2222 38.8377 50.8772ZM54.0132 42.807C52.5512 44.269 50.7968 45 48.75 45C46.7032 45 44.9488 44.269 43.4868 42.807C42.0249 41.345 41.2939 39.5906 41.2939 37.5439C41.2939 35.4971 42.0249 33.7427 43.4868 32.2807C44.9488 30.7602 46.7032 30 48.75 30C50.7968 30 52.5512 30.7602 54.0132 32.2807C55.4751 33.7427 56.2061 35.4971 56.2061 37.5439C56.2061 39.5906 55.4751 41.345 54.0132 42.807Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 45L28.5 37.5V42.9545H22.5V47.0455H28.5V52.5L37.5 45Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignedIcon);
export default __webpack_public_path__ + "static/media/assigned-icon.ffded2b84285586ab2d8c99e61d6e187.svg";
export { ForwardRef as ReactComponent };